module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-ii/banner@2x-f2220ee51381f88368140d76aa25f478.jpg";